import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { IPaymentAuthorizationStats } from 'interfaces/stripe';

interface IUsePaymentAuthorizationStatsParams {
  shouldRun?: boolean;
}

const usePaymentAuthorizationStats = ({
  shouldRun = true,
}: IUsePaymentAuthorizationStatsParams = {}) => {
  const url = '/payments/stats';
  const clinicId = loadSelectedClinicId();

  const { data, error, mutate } = useSWR<IPaymentAuthorizationStats>(
    shouldRun ? [url, clinicId] : false,
    async (...resource) => {
      const [requestUrl] = resource;
      const response = await axiosInstance.get(requestUrl);

      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default usePaymentAuthorizationStats;
